import { EnvironmentStage, ProfileSections } from "../types/types";
export const defaultProfile = {
    id: "",
    userId: "",
    name: "",
    email: "",
    isStaff: false,
    alias: "",
    firstName: "",
    lastName: "",
    picture: "",
    bio: "",
    interests: [],
    company: {
        address: null,
        name: "",
        size: null,
        type: null,
        website: null,
    },
    job: {
        role: null,
        title: "",
        industry: null,
    },
    location: {
        countryRegion: "",
        stateProvince: "",
        postalCode: "",
        city: "",
    },
    socials: {
        github: null,
        linkedIn: null,
        twitter: null,
        youtube: null,
        personal: null,
        repost: null,
        facebook: null,
        devto: null,
        blog: null,
    },
    appStatuses: [],
    engagement: {
        complianceRequesterType: null,
        interestReason: null,
        projectTimeFrame: null,
        useCase: null,
        usageLevel: null,
    },
    communications: {
        phone: "",
        businessEmail: "",
        complianceOptIn: false,
        koreanComplianceOptIn: null,
    },
    lastSyncToMarketoDate: null,
    createdOn: 1,
    updatedOn: 1,
};
export const profileWithData = {
    id: "5545f520-f637-42df-bd55-a06d1923f8f9",
    userId: "7418f428-8041-7088-ec9f-cb4f63bdea71",
    firstName: "DTgBEvIqvK",
    lastName: "naZdlEaujm",
    avatar: "https://gamma-avatars.builderprofile.aws.dev/31c9GXhmJnLWdGvFp4apIOh5QFc.webp",
    bio: "JohnDoe bio",
    interests: ["Chime", "Python", "JavaScript", "Alexa", "Apache Airflow"],
    alias: "identity1",
    name: "JohnDoe",
    communications: {
        phone: "1234567890",
        businessEmail: "john.doe@company.com",
        complianceOptIn: null,
        koreanComplianceOptIn: false,
    },
    location: {
        countryRegion: "US",
        postalCode: "94105",
        stateProvince: "WA",
        city: "San Francisco",
    },
    displayLocation: {
        countryRegion: "US",
        stateProvince: "WA",
    },
    engagement: {
        complianceRequesterType: "Business",
        interestReason: null,
        projectTimeFrame: "OneToThreeMonths",
        useCase: "BatchProcessing",
        usageLevel: "DevelopmentAndTesting",
    },
    job: {
        industry: "Aerospace",
        role: "DeveloperOrEngineer",
        title: "Senior Developer",
    },
    company: {
        name: "AWS",
        type: "Enterprise",
        size: "Startup",
    },
    socials: {
        blog: "example.com/johndoe",
        devto: "dev.to/chocoscoding",
        facebook: "facebook.com/johndoe",
        github: "github.com/johndoe",
        linkedIn: "linkedin.com/in/johndoe",
        personal: null,
        repost: "repost.aws/community/users/johndoe",
        twitter: "x.com/johndoe",
        youtube: "youtube.com/johndoe",
    },
    additionalEmails: [
        {
            email: "aws-accs-func-test+001@amazon.com",
            status: "Unverified",
            type: "Personal",
            createdOn: 1755812016392,
            updatedOn: 1755812199018,
            verifiedOn: 1755812199018,
            tag: {
                isUsernameEmail: false,
                isTrainingCertificationEmail: false,
                isRePostEmail: false,
                isStartUpsEmail: false,
            },
        },
        {
            email: "aws-accs-func-test+002@amazon.com",
            status: "Unverified",
            type: "Personal",
            createdOn: 1755811787467,
            updatedOn: 1755811927117,
            verifiedOn: 1755811897503,
            tag: {
                isUsernameEmail: false,
                isTrainingCertificationEmail: false,
                isRePostEmail: false,
                isStartUpsEmail: false,
            },
        },
    ],
    lastSyncToMarketoDate: 1737054952028,
    tokenProvider: {
        type: "BuilderId",
    },
    email: "aws-mrktg-identity-support+1@amazon.com",
};
export const defaultBPConfig = {
    [EnvironmentStage.ALPHA]: {
        api: "https://gamma-api-v2.builderprofile.aws.dev",
        tokenApi: "https://alpha.auth-builderprofile.aws.dev",
        auth: "https://alpha.auth-builderprofile.aws.dev",
        clientId: "Qt_xtFLhynvUdzWFxPB5gHVzLWVhc3QtMQ",
    },
    [EnvironmentStage.BETA]: {
        api: "https://gamma-api-v2.builderprofile.aws.dev",
        tokenApi: "https://alpha.auth-builderprofile.aws.dev",
        auth: "https://beta.auth-builderprofile.aws.dev",
        clientId: "Qt_xtFLhynvUdzWFxPB5gHVzLWVhc3QtMQ",
    },
    [EnvironmentStage.GAMMA]: {
        api: "https://gamma-api-v2.builderprofile.aws.dev",
        tokenApi: "https://alpha.auth-builderprofile.aws.dev",
        auth: "https://gamma.auth-builderprofile.aws.dev",
        clientId: "Qt_xtFLhynvUdzWFxPB5gHVzLWVhc3QtMQ",
    },
    [EnvironmentStage.PROD]: {
        api: "https://api-v2.builderprofile.aws.dev",
        tokenApi: "https://alpha.auth-builderprofile.aws.dev",
        auth: "https://auth-builderprofile.aws.dev",
        clientId: "H4RyPM6-tp_7d1fK49j2Y3VzLWVhc3QtMQ",
    },
};
export const defaultAdapterConfig = {
    env: EnvironmentStage.ALPHA,
    bpConfig: defaultBPConfig,
};
export const FederateTokenProviderType = "Federate";
export var APIErrorCodes;
(function (APIErrorCodes) {
    APIErrorCodes["TooManyRequests"] = "TOO_MANY_REQUESTS";
    APIErrorCodes["ClientError"] = "CLIENT_ERROR";
    APIErrorCodes["BioModeration"] = "BIO_MODERATION";
    APIErrorCodes["AliasalreadyAssigned"] = "ALIAS_ALREADY_ASSIGNED";
})(APIErrorCodes || (APIErrorCodes = {}));
export var APIErrorMessages;
(function (APIErrorMessages) {
    APIErrorMessages["TooManyRequests"] = "Too many OTP requested.";
    APIErrorMessages["TooManyRequestsPerDay"] = "Too many OTP requested. Please wait for 24 hours.";
})(APIErrorMessages || (APIErrorMessages = {}));
export const DefaultSections = [
    ProfileSections.User,
    ProfileSections.Emails,
    ProfileSections.Community,
    ProfileSections.Interests,
    ProfileSections.Work,
    ProfileSections.Communications,
];
export const MAX_EMAILS = 5;
//# sourceMappingURL=profile.js.map